import { BenefitModalProps } from '../../../../../@types/benefitModalProps';
import { AragModal } from '../aragModal/AragModal';
import MediationJpg from './images/rent_legal.jpg';
import MediationWebp from './images/rent_legal.webp';
import MediationMobileJpg from './images/rent_legal_mobile.jpg';
import MediationMobileWebp from './images/rent_legal_mobile.jpg';
import PhonePng from './images/phone.png';
import PhoneWebp from './images/phone.webp';
import Section3Png from './images/section3.png';
import Section3Webp from './images/section3.webp';
import { InsuranceServiceName } from '@/@types/insurance';

export const Mediation = ({ isVisible, onClose }: BenefitModalProps) => {
  return (
    <AragModal
      serviceName={InsuranceServiceName.MEDIATION}
      image={MediationJpg}
      imageWebp={MediationWebp}
      imageMobile={MediationMobileJpg}
      imageMobileWebp={MediationMobileWebp}
      howItWorksImage1Png={PhonePng}
      howItWorksImage1WebP={PhoneWebp}
      howItWorksImage2Png={Section3Png}
      howItWorksImage2WebP={Section3Webp}
      isVisible={isVisible}
      onClose={onClose}
    />
  );
};

export default Mediation;
